import { useMemo } from 'react';
import usePriceList from './usePriceList';
import useWatcherNetworks from './useWatcherNetworks';

/**
 * useWatcherPriceList
 */
export default function useWatcherPriceList() {
  const { data } = useWatcherNetworks();
  const symbols = useMemo(
    () => data?.data.data?.map(item => item.symbol),
    [data]
  );
  return usePriceList(symbols);
}
